/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class SalesQuery extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default SalesQuery;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/salesQuery.js